import { z } from 'zod';
import { AIPromptSchema, AIModelSchema } from './jobs.schema';

// AI Request (uses existing schemas from jobs.schema)
export const AIRequestSchema = z.object({
  prompt: AIPromptSchema,
  model: AIModelSchema.optional(),
  systemPrompt: z.string().optional(),
  parameters: z.record(z.string(), z.any()).optional(),
  metadata: z.record(z.string(), z.any()).optional(),
});
export type AIRequest = z.infer<typeof AIRequestSchema>;
